import { createContext } from 'react'

const DaiOptOutContext = createContext()

export default DaiOptOutContext
